import { gql } from '@apollo/client';
/**
 * @fragment FileFragment
 * @since 1.0.0
 */
export const FileFragment = gql `
  fragment FileFragment on File {
    filename
    filepath
    filedata
    filesize
    mimetype
  }
`;
